import Address from './Address';
import PhoneNumber from './PhoneNumber';

export default class Client {
    public id: number;
    public clientBillingId?: number;
    public clientSettingsId?: number;
    public clientNumber: number;
    public isShadow: boolean;
    // TODO: consolidating or breaking apart the three name properties.
    public name: string;
    public cloakName: string;
    public isRealVisible: boolean;
    public calmsSourced: boolean;

    // Not mapped
    public isFavorite: boolean;

    address: Address;
    phoneNumber: PhoneNumber;
    webSite: string;

    constructor() {
        this.address = new Address();
        this.phoneNumber = new PhoneNumber();
    }
}



// WEBPACK FOOTER //
// ./src/models/Client.ts